import { AssetModel } from "../AssetModel";
import { PersonModel } from "../PersonModel";
import { MachineInspectionParamModel } from "./MachineInspectionParamModel";

export class MachineInspectionModel {
    constructor({ id, responsible, ativo: machine, doneAt, params, status, isWorking, remarks }) {
        this.id = id;
        this.responsible = responsible;
        this.machine = machine;
        this.doneAt = doneAt;
        this.params = params;
        this.status = status;
        this.isWorking = isWorking;
        this.remarks = remarks;
    }

    static fromJson(json) {
        return new MachineInspectionModel({
            id: json.id,
            responsible: PersonModel.fromJson(json.responsavel),
            ativo: AssetModel.fromJson(json.ativo),
            doneAt: json.created_at ?? json.realizada_em,
            params: json.parametros != null ? json.parametros.map((e) => MachineInspectionParamModel.fromJson(e)) : [],
            status: json.status ?? true,
            isWorking: !(json.parada == 1 || json.parada == true) ?? true,
            remarks: json.observacoes,
        });
    }
}
